import React from "react";
import Chip from "../Chip";
import { grey } from "@mui/material/colors";
import MUIAvatar from "@mui/material/Avatar";
import ProductSubType from "../../Utility/Crud/ProductSubType";

export default class ChipOrderActivityProductSubType extends Chip {
  /**
   * Renders a MUI Avatar.
   */
  renderAvatar() {
    const color = this.props.productSubType
      ? ProductSubType.getColor()
      : grey[500];
    const avatarColor = this.props.isTransparent ? "transparent" : color;
    const iconColor = this.props.isTransparent ? color : "#fff";

    return (
      <MUIAvatar sx={{ bgcolor: avatarColor }}>
        {ProductSubType.getIcon({
          fontSize: "small",
          sx: { color: iconColor },
        })}
      </MUIAvatar>
    );
  }

  /**
   * @return {string} The productSubType name.
   */
  getLabel() {
    return this.props.productSubType
      ? ProductSubType.getDisplayName(this.props.productSubType)
      : "None";
  }
}
